<template>
    <div>

<b-button v-b-modal.modal-ag variant="primary" @click="addClick()" style="margin-top: 20px;">
    Agregar un marcador
</b-button>

<table class="table table-striped">

    <thead>

        <tr>

            <!--<th>
            
                
                <div class="d-flex flex-row">

                <input class="form-control m-2"
                    v-model="MarcadorIDFilter"
                    v-on:keyup="FilterFn()"
                    placeholder="Filtrar">
                    
                    <button type="button" class="btn btn-light"
                    @click="sortResult('MarcadorID',true)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
                    <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
                    </svg>
                    </button>
                    &nbsp;
                    <button type="button" class="btn btn-light"
                    @click="sortResult('MarcadorID',false)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
                    <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
                    </svg>
                    </button>

                </div>
                ID
            
            </th>-->
            <th>

                <div class="d-flex flex-row">

                <input class="form-control m-2"
                    v-model="MarcadorFilter"
                    v-on:keyup="FilterFn()"
                    placeholder="Filtrar">
                    
                    <button type="button" class="btn btn-light"
                    @click="sortResult('Marcador',true)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-down-square-fill" viewBox="0 0 16 16">
                    <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm6.5 4.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 1 1 .708-.708L7.5 10.293V4.5a.5.5 0 0 1 1 0z"/>
                    </svg>
                    </button>
                    &nbsp;
                    <button type="button" class="btn btn-light"
                    @click="sortResult('Marcador',false)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-up-square-fill" viewBox="0 0 16 16">
                    <path d="M2 16a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2zm6.5-4.5V5.707l2.146 2.147a.5.5 0 0 0 .708-.708l-3-3a.5.5 0 0 0-.708 0l-3 3a.5.5 0 1 0 .708.708L7.5 5.707V11.5a.5.5 0 0 0 1 0z"/>
                    </svg>
                    </button>
    
                </div>
                Marcadores discursivos
                
            </th>
            <th>Opciones</th>

        </tr>

    </thead>

    <tbody>
        <tr v-for="(marcador, index) in marcadores" :key="index">

            <!--<td>{{marcador.MarcadorID}}</td>-->
            <td>{{marcador.Marcador}}</td>

            <td>
            <b-button v-b-modal.modal-ag variant="light" @click="editClick(marcador)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                </svg>
            </b-button>
            &nbsp;
            <b-button variant="light" @click="deleteClick(marcador.MarcadorID)">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-trash-fill" viewBox="0 0 16 16">
                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
                </svg>
            </b-button>

            </td>

        </tr>
    </tbody>

</table>

    <!--
    <button class="btn btn-primary" type="button" disabled>
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        Cargando...
    </button>
    -->


<b-modal id="modal-ag" size="lg" hide-footer hide-header centered>
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">{{modalTitle}}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="$bvModal.hide('modal-ag')">
                </button>
            </div>

    <div class="modal-body">

        <div class="input-group mb-3">
            <p>
            <span class="input-group-text">Marcador</span><input type="text" class="form-control" v-model="Marcador">
            <span class="input-group-text">Clasificación</span> <input type="text" class="form-control" v-model="Clasificacion">
            <span class="input-group-text">Significado</span> <input type="text" class="form-control" v-model="Significado">
            <span class="input-group-text">Región</span> <input type="text" class="form-control" v-model="Region">
            <span class="input-group-text">Traducciones</span> <input type="text" class="form-control" v-model="Traducciones">
            <span class="input-group-text">Marcación gramatical</span> <input type="text" class="form-control" v-model="Marcacion_gramatical">
            <span class="input-group-text">DRAE</span> <input type="text" class="form-control" v-model="DRAE">
            <span class="input-group-text">Aspectos Morfológicos</span> <input type="text" class="form-control" v-model="Aspectos_morfologicos">
            <span class="input-group-text">Variantes</span> <input type="text" class="form-control" v-model="Variantes">
            <span class="input-group-text">Sinónimo</span> <input type="text" class="form-control" v-model="Sinonimo">
            </p>
            &nbsp;&nbsp;&nbsp;
            <p>
            <span class="input-group-text">Antónimo</span> <input type="text" class="form-control" v-model="Antonimo">
            <span class="input-group-text">Palabras diacríticas</span> <input type="text" class="form-control" v-model="Palabras_diacriticas">
            <span class="input-group-text">Número</span> <input type="text" class="form-control" v-model="Numero">
            <span class="input-group-text">Argumentos</span> <input type="text" class="form-control" v-model="Argumentos">
            <span class="input-group-text">Polaridad</span> <input type="text" class="form-control" v-model="Polaridad">
            <span class="input-group-text">Aspectos pragmáticos</span> <input type="text" class="form-control" v-model="Aspectos_pragmaticos">
            <span class="input-group-text">Prosodia y puntuación</span> <input type="text" class="form-control" v-model="Prosodia_puntuacion">
            <span class="input-group-text">Combinación con otras UF</span> <input type="text" class="form-control" v-model="Combinacion_otras_UF">
            <span class="input-group-text">Posición</span> <input type="text" class="form-control" v-model="Posicion">
            <span class="input-group-text">Registro</span> <input type="text" class="form-control" v-model="Registro">
            </p>
            &nbsp;&nbsp;&nbsp;
            <p>
            <span class="input-group-text">Ejemplo 1</span> <textarea class="form-control" v-model="Ejemplo_1"></textarea>
            
            <span class="input-group-text">Ejemplo 2</span> <textarea class="form-control" v-model="Ejemplo_2"></textarea>
            
            <span class="input-group-text">Ejemplo 3</span> <textarea class="form-control" v-model="Ejemplo_3"></textarea>
            
            <span class="input-group-text">Ejemplo 4</span> <textarea class="form-control" v-model="Ejemplo_4"></textarea>
            
            <span class="input-group-text">Ejemplo 5</span> <textarea class="form-control" v-model="Ejemplo_5"></textarea>
            
            </p>

        </div>

        <div>
            <span> <b>Audio: </b>
                <audio controls="controls" type="audio/mpeg" preload="preload" :src="AudioPath+AudioFileName">
                </audio> 
                <input class="m-2" type="file" @change="audioUpload">
            </span>
        </div>

        <div>
            <button type="button" @click="createClick()"
            v-if="MarcadorID==0" class="btn btn-primary">
            Agregar
            </button>
            <button type="button" @click="updateClick()"
            v-if="MarcadorID!=0" class="btn btn-primary">
            Actualizar
            </button>
        </div>
    </div>
</b-modal>

<!--
<div style="margin-top: 20px;">
    <nav aria-label="Page navigation example">
    <ul class="pagination">
        <li class="page-item"><a class="page-link" href="#">Anterior</a></li>
        <li class="page-item"><a class="page-link" href="#">1</a></li>
        <li class="page-item"><a class="page-link" href="#">2</a></li>
        <li class="page-item"><a class="page-link" href="#">3</a></li>
        <li class="page-item"><a class="page-link" href="#">Siguiente</a></li>
    </ul>
    </nav>
</div>
-->

</div>
</template>

<script>

import firebase from "firebase/compat/app";
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import 'firebase/compat/analytics';

import axios from 'axios';

export default {
    
  data(){

    return{
        user:'',
        marcadores:[],
        modalTitle:"",
        Marcador:"",
        MarcadorID:0,
        Clasificacion:"",
        Significado:"",
        Region:"",
        Traducciones:"",
        Marcacion_gramatical:"",
        Ejemplo_1:"",
        Ejemplo_2:"",
        Ejemplo_3:"",
        Ejemplo_4:"",
        Ejemplo_5:"",
        DRAE:"",
        Aspectos_morfologicos:"",
        Variantes:"",
        Sinonimo:"",
        Antonimo:"",
        Palabras_diacriticas:"",
        Numero:"",
        Argumentos:"",
        Polaridad:"",
        Aspectos_pragmaticos:"",
        Prosodia_puntuacion:"",
        Combinacion_otras_UF:"",
        Posicion:"",
        Registro:"",
        MarcadorFilter:"",
        MarcadorIDFilter:"",
        MarcadoresWithoutFilter:[],
        AudioFileName:"",
        AudioPath:"http://difraco.com.co:8000/Media/"
    }
},

created() {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.user = user;
      } else {
        this.$router.push('/admin')
      }
    });
  },

methods:{
    refreshData(){
        axios.get("http://difraco.com.co:8000/marcador")
        .then((response)=>{
            this.marcadores=response.data;
            this.marcadoresWithoutFilter=response.data;
        })
    },

    especificacionesClick(marcador){
        this.modalTitle=marcador.Marcador;
        this.Marcador=marcador.Marcador;
        this.MarcadorID=marcador.MarcadorID;
        this.Clasificacion=marcador.Clasificacion;
        this.Significado=marcador.Significado;
        this.Region=marcador.Region;
        this.Traducciones=marcador.Traducciones;
        this.Marcacion_gramatical=marcador.Marcacion_gramatical;
        this.Ejemplo_1=marcador.Ejemplo_1;
        this.Ejemplo_2=marcador.Ejemplo_2;
        this.Ejemplo_3=marcador.Ejemplo_3;
        this.Ejemplo_4=marcador.Ejemplo_4;
        this.Ejemplo_5=marcador.Ejemplo_5;
        this.DRAE=marcador.DRAE;
        this.Aspectos_morfologicos=marcador.Aspectos_morfologicos;
        this.Variantes=marcador.Variantes;
        this.Sinonimo=marcador.Sinonimo;
        this.Antonimo=marcador.Antonimo;
        this.Palabras_diacriticas=marcador.Palabras_diacriticas;
        this.Numero=marcador.Numero;
        this.Argumentos=marcador.Argumentos;
        this.Polaridad=marcador.Polaridad;
        this.Aspectos_pragmaticos=marcador.Aspectos_pragmaticos;
        this.Prosodia_puntuacion=marcador.Prosodia_puntuacion;
        this.Combinacion_otras_UF=marcador.Combinacion_otras_UF;
        this.Posicion=marcador.Posicion;
        this.Registro=marcador.Registro;
        this.MarcadorFilter=marcador.MarcadorFilter;
        this.AudioFileName=marcador.AudioFileName
      
  },

    addClick(){
        this.modalTitle="Agregar un marcador";
        this.MarcadorID=0;
        this.Marcador="";
        this.Clasificacion="";
        this.Significado="";
        this.Region="";
        this.Traducciones="";
        this.Marcacion_gramatical="";
        this.Ejemplo_1="";
        this.Ejemplo_2="";
        this.Ejemplo_3="";
        this.Ejemplo_4="";
        this.Ejemplo_5="";
        this.DRAE="";
        this.Aspectos_morfologicos="";
        this.Variantes="";
        this.Sinonimo="";
        this.Antonimo="";
        this.Palabras_diacriticas="";
        this.Numero="";
        this.Argumentos="";
        this.Polaridad="";
        this.Aspectos_pragmaticos="";
        this.Prosodia_puntuacion="";
        this.Combinacion_otras_UF="";
        this.Posicion="";
        this.Registro="";
        this.MarcadorFilter="";
        this.AudioFileName=""
    },
    editClick(marcador){
        this.modalTitle="Editar marcador";
        this.MarcadorID=marcador.MarcadorID;
        this.Marcador=marcador.Marcador;
        this.Clasificacion=marcador.Clasificacion;
        this.Significado=marcador.Significado;
        this.Region=marcador.Region;
        this.Traducciones=marcador.Traducciones;
        this.Marcacion_gramatical=marcador.Marcacion_gramatical;
        this.Ejemplo_1=marcador.Ejemplo_1;
        this.Ejemplo_2=marcador.Ejemplo_2;
        this.Ejemplo_3=marcador.Ejemplo_3;
        this.Ejemplo_4=marcador.Ejemplo_4;
        this.Ejemplo_5=marcador.Ejemplo_5;
        this.DRAE=marcador.DRAE;
        this.Aspectos_morfologicos=marcador.Aspectos_morfologicos;
        this.Variantes=marcador.Variante;
        this.Sinonimo=marcador.Sinonimo;
        this.Antonimo=marcador.Antonimo;
        this.Palabras_diacriticas=marcador.Palabras_diacriticas;
        this.Numero=marcador.Numero;
        this.Argumentos=marcador.Argumentos;
        this.Polaridad=marcador.Polaridad;
        this.Aspectos_pragmaticos=marcador.Aspectos_pragmaticos;
        this.Prosodia_puntuacion=marcador.Prosodia_puntuacion;
        this.Combinacion_otras_UF=marcador.Combinacion_otras_UF;
        this.Posicion=marcador.Posicion;
        this.Registro=marcador.Registro;
        this.MarcadorFilter=marcador.MarcadorFilter;
        this.AudioFileName=marcador.AudioFileName
        
    },
    createClick(){
        axios.post("http://difraco.com.co:8000/marcador",{
            Marcador:this.Marcador,
            Clasificacion:this.Clasificacion,
            Significado:this.Significado,
            Region:this.Region,
            Traducciones:this.Traducciones,
            Marcacion_gramatical:this.Marcacion_gramatical,
            Ejemplo_1:this.Ejemplo_1,
            Ejemplo_2:this.Ejemplo_2,
            Ejemplo_3:this.Ejemplo_3,
            Ejemplo_4:this.Ejemplo_4,
            Ejemplo_5:this.Ejemplo_5,
            DRAE:this.DRAE,
            Aspectos_morfologicos:this.Aspectos_morfologicos,
            Variantes:this.Variantes,
            Sinonimo:this.Sinonimo,
            Antonimo:this.Antonimo,
            Palabras_diacriticas:this.Palabras_diacriticas,
            Numero:this.Numero,
            Argumentos:this.Argumentos,
            Polaridad:this.Polaridad,
            Aspectos_pragmaticos:this.Aspectos_pragmaticos,
            Prosodia_puntuacion:this.Prosodia_puntuacion,
            Combinacion_otras_UF:this.Combinacion_otras_UF,
            Posicion:this.Posicion,
            Registro:this.Registro,
            MarcadorFilter:this.MarcadorFilter,
            AudioFileName:this.AudioFileName
        })
        .then((response)=>{
            this.refreshData();
            alert(response.data);
        });
    },
    updateClick(){
        axios.put("http://difraco.com.co:8000/marcador",{
            MarcadorID:this.MarcadorID,
            Marcador:this.Marcador,
            Clasificacion:this.Clasificacion,
            Significado:this.Significado,
            Region:this.Region,
            Traducciones:this.Traducciones,
            Marcacion_gramatical:this.Marcacion_gramatical,
            Ejemplo_1:this.Ejemplo_1,
            Ejemplo_2:this.Ejemplo_2,
            Ejemplo_3:this.Ejemplo_3,
            Ejemplo_4:this.Ejemplo_4,
            Ejemplo_5:this.Ejemplo_5,
            DRAE:this.DRAE,
            Aspectos_morfologicos:this.Aspectos_morfologicos,
            Variantes:this.Variantes,
            Sinonimo:this.Sinonimo,
            Antonimo:this.Antonimo,
            Palabras_diacriticas:this.Palabras_diacriticas,
            Numero:this.Numero,
            Argumentos:this.Argumentos,
            Polaridad:this.Polaridad,
            Aspectos_pragmaticos:this.Aspectos_pragmaticos,
            Prosodia_puntuacion:this.Prosodia_puntuacion,
            Combinacion_otras_UF:this.Combinacion_otras_UF,
            Posicion:this.Posicion,
            Registro:this.Registro,
            MarcadorFilter:this.MarcadorFilter,
            AudioFileName:this.AudioFileName
        })
        .then((response)=>{
            this.refreshData();
            alert(response.data);
        });
    },
    deleteClick(id){
        if(!confirm("¿Está seguro de que quiere borrar?")){
            return;
        }
        axios.delete("http://difraco.com.co:8000/marcador/"+id)
        .then((response)=>{
            this.refreshData();
            alert(response.data);
        });

    },
    FilterFn(){
        var MarcadorIDFilter=this.MarcadorIDFilter;
        var MarcadorFilter=this.MarcadorFilter;

        this.marcadores=this.marcadoresWithoutFilter.filter(
            function(el){
                return el.MarcadorID.toString().toLowerCase().includes(
                    MarcadorIDFilter.toString().trim().toLowerCase()
                )&&
                el.Marcador.toString().toLowerCase().includes(
                    MarcadorFilter.toString().trim().toLowerCase()
                )
            });
    },
    sortResult(prop,asc){
        this.marcadores=this.marcadoresWithoutFilter.sort(function(a,b){
            if(asc){
                return (a[prop]>b[prop])?1:((a[prop]<b[prop])?-1:0);
            }
            else{
                return (b[prop]>a[prop])?1:((b[prop]<a[prop])?-1:0);
            }
        })
    },

    audioUpload(event){
        let formData=new FormData();
        formData.append('file',event.target.files[0]);
        axios.post(
            "http://difraco.com.co:8000/marcador/savefile",
            formData)
            .then((response)=>{
                this.AudioFileName=response.data;
            });
    },

},

mounted:function(){
    this.refreshData();
}
  
};
</script>
